import React from 'react';
import '../styles/RutasPuerto.css'; 

export default function RutasList({ routes }) {
  if (!routes || routes.length === 0) {
    return (
      <section className="rutas-section">
        <h2>Rutas Principales</h2>
        <p>No hay rutas principales registradas para este puerto.</p>
      </section>
    );
  }

  return (
    <section className="rutas-section">
      <h2>Rutas Principales</h2>
      <div className="rutas-list-container">
        {routes.map((rutaName) => (
          <div key={rutaName} className="ruta-card-simple">
            <span>
              <i className="fas fa-route ruta-icon-simple"></i>
              {rutaName}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}